export function ServiceDetails() {
  const details = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Pool Plaster Repair',
      description: 'Expert pool resurfacing and plaster repair to restore your pool to pristine condition with durable, long-lasting materials.'
    },
    {
      icon: 'ri-seedling-line',
      title: 'Synthetic Grass Installation',
      description: 'Premium artificial turf installation for beautiful, low-maintenance lawns that stay green year-round in the Las Vegas climate.'
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Paver Installation',
      description: 'Custom paver designs for driveways, patios, and walkways using high-quality materials and expert craftsmanship.'
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'HVAC Services',
      description: 'Complete heating and cooling solutions including installation, repair, and maintenance for optimal home comfort.'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Roofing Solutions',
      description: 'Professional roofing services from repairs to complete replacements, ensuring your property is protected.'
    },
    {
      icon: 'ri-drop-line',
      title: 'Water Filtration Systems',
      description: 'Water softener and filtration system installation for cleaner, healthier water throughout your property.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-2 h-2 bg-[#FF6B35] rounded-full"></div>
            <span className="text-[#FF6B35] text-sm font-semibold tracking-wider uppercase">Service Details</span>
          </div>
          <h2 className="text-5xl font-bold text-[#2C2C2C] mb-4">What We Do Best</h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Comprehensive construction and remodeling services delivered with precision and care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {details.map((detail, index) => (
            <div 
              key={index}
              className="bg-[#F5F5F5] rounded-xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer group"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B35] to-[#E55A2B] rounded-full flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <i className={`${detail.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{detail.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{detail.description}</p>
              <div className="flex items-center gap-2 text-[#FF6B35] font-semibold text-sm cursor-pointer hover:gap-3 transition-all">
                Details <i className="ri-arrow-right-s-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
